import '@theme/theme-drawer';

function cartDrawer() {
  return document.getElementById('cart-drawer');
}

function updateTriggers(open) {
  for (const trigger of document.querySelectorAll('[aria-controls="cart-drawer"]')) {
    trigger.setAttribute('aria-expanded', String(open));
  }
}

document.addEventListener('click', event => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
  const url = new URL(link.href, window.location.href);
  const root = window.Shopify?.routes?.root || '/';
  if (url.origin !== window.location.origin || url.pathname.replace(/\/$/, '') !== root.replace(/\/$/, '') + '/cart') return;
  const drawer = cartDrawer();
  if (!drawer || typeof drawer.open !== 'function') return;
  event.preventDefault();
  event.stopImmediatePropagation();
  drawer.open();
}, true);

document.addEventListener('theme-drawer:open', event => {
  if (event.target === cartDrawer()) updateTriggers(true);
});

document.addEventListener('theme-drawer:close', event => {
  if (event.target === cartDrawer()) updateTriggers(false);
});
